import { useEffect, useState } from 'react'

import { Box, Stack } from '@mantine/core'
import { v4 as uuidv4 } from 'uuid'
import { UserScopesApiDTO } from '../../codegen/generated/Api.schemas'
import { UserScopesStructure } from '../../types/UserScopes'
import { UserScopesItem } from './UserScopesItem'

type UpdateUserScopesProps = {
  scopes?: UserScopesApiDTO
  onUpdate: (scopes: UserScopesApiDTO) => void
}

export const UpdateUserScopes = ({ scopes, onUpdate }: UpdateUserScopesProps) => {
  const [scopesItems, setUserScopesItems] = useState<UserScopesStructure>({
    id: uuidv4(),
    cms: scopes?.cms && scopes?.cms?.[0] !== '*' ? scopes?.cms : [],
    beneficiariesIds:
      scopes?.beneficiariesIds && scopes?.beneficiariesIds?.[0] !== '*'
        ? scopes?.beneficiariesIds
        : [],
    youtubeChannelsIds:
      scopes?.youtubeChannelsIds && scopes?.youtubeChannelsIds?.[0] !== '*'
        ? scopes?.youtubeChannelsIds
        : [],
  })

  useEffect(() => {
    const { id, ...scopes } = scopesItems
    onUpdate(scopes as UserScopesApiDTO)
  }, [scopesItems])

  return (
    <Box w="100%">
      <Stack gap={3}>
        <UserScopesItem
          scopesItems={scopesItems}
          onUpdate={scope => {
            setUserScopesItems(scope)
          }}
        />
      </Stack>
    </Box>
  )
}
